<script>
    export let left = "1rem";
    export let right = "1rem";
    export let top = "1rem";
    export let bottom = "1rem";
</script>

<div style="padding: {top} {right} {bottom} {left}">
    <slot /> 
</div>